import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BankProductFormFields } from "web_myplann/Portfolio/Forms/BankProductForm/BankProductFormFields";
import { useEditBankProductForm } from "web_myplann/Portfolio/Forms/BankProductForm/useEditBankProductForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditBankProductFormProps = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const EditBankProductForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: EditBankProductFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useEditBankProductForm({
		portfolioId,
		portfolio,
		detailRoute,
	});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditPortfolio.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<BankProductFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
